// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"10":"09b9607b","169":"4da54792","247":"a7602133","382":"41361a28","453":"e3ccf950","473":"fbb087fd","536":"4b25635a","579":"6fa20308","656":"1f7b0fce","670":"f3de2a2f","858":"ed6c8b6a","912":"e271ce50","938":"6b3b0f52","988":"c0eb57c5"}[chunkId] + ".chunk.js";
};